<template>
  <section>
    <b-skeleton-table
      v-if="isLoading"
      :rows="10"
      :columns="4"
    />
    <template v-if="!isLoading">
      <b-card
        no-body
        footer-class="d-flex"
        class="client-table"
      >
        <b-table
          :items="wrapper"
          :fields="sharedCatalogsColumns"
          class="client-table__data catalog-list-table"
          show-empty
          :empty-text="$tk('ClientPortal.Catalogs.NoCatalogsHaveBeenSharedWithYou')"
          responsive
        >
          <template #empty="scope">
            <div class="text-center p-3 client-table__empty">
              <div class="empty__client-table">
                <GjIcon
                  size="64px"
                  name="Book"
                />
                <div class="mb-50">
                  {{ scope.emptyText }}
                </div>
              </div>
            </div>
          </template>
          <template #cell(name)="data">
            <i
              v-b-tooltip.hover="data.item.status"
              class="mr-50"
              :class="getCatalogStatusIcon(data.item.status)"
            />
            <b-link :to="'/' + $route.params.accountId +'/catalogs/' + data.item.encodedId + '/details'">
              {{ data.item.name }}
            </b-link>
          </template>
          <template #cell(catalogItemsCount)="data">
            {{ formatInteger(data.item.catalogItemsCount) }}
          </template>
          <template #cell(catalogAdvertisingPrivacyType)="data">
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ data.item.catalogAdvertisingPrivacyType }}</span>
              <b-button
                class="text-secondary mr-1 font-weight-normal"
                variant="link"
                :to="'/' + $route.params.accountId +'/catalogs/' + data.item.encodedId + '/details'"
              >
                <GjIcon
                  name="Show"
                  size="22"
                  class="mr-25"
                />
                {{ $tk('ClientPortal.Form.ViewCatalogItems') }}
              </b-button>
            </div>
          </template>
        </b-table>
      </b-card>
    </template>
  </section>
</template>
<script>
import translation from '@/mixins/translate'
import CatalogsService from '@/api/client/catalogs.service'
import {
  onMounted,
  ref,
  computed,
  watch,
} from '@vue/composition-api'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  setup(props, context) {
    const isLoading = ref(false)
    const wrapper = ref([])
    const accountId = computed(() => context.root.$route.params.accountId)
    watch(accountId, async () => {
      wrapper.value = await CatalogsService.getSharedCatalogs(accountId.value)
    })
    const sharedCatalogsColumns = [
      {
        key: 'name',
        label: translation.methods.$tk('ClientPortal.Catalogs.Name'),
      },
      {
        key: 'type',
        label: translation.methods.$tk('ClientPortal.Catalogs.Type'),
      },
      {
        key: 'catalogItemsCount',
        label: translation.methods.$tk('ClientPortal.Catalogs.CatalogItemsCount'),
      },
      {
        key: 'catalogAdvertisingPrivacyType',
        label: translation.methods.$tk('ClientPortal.Catalogs.CatalogAdvertisingPrivacyType'),
      },
    ]

    onMounted(async () => {
      isLoading.value = true
      wrapper.value = await CatalogsService.getSharedCatalogs(accountId.value)
      isLoading.value = false
    })

    const getCatalogStatusIcon = status => {
      switch (status) {
        case 'Pending':
          return 'chart-dot-blue'
        case 'Processing':
          return 'chart-dot-orange'
        case 'Finished':
          return 'chart-dot-green'
        default:
          return 'chart-dot-blue'
      }
    }

    const formatInteger = value => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    return {
      sharedCatalogsColumns,
      isLoading,
      wrapper,
      getCatalogStatusIcon,
      formatInteger,
    }
  },
}
</script>
